export default "__VITE_ASSET__752a612e__"